import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// import Navbar from "../../NavBar";
import "./LeaderTasks.css";
import axios from "axios";
import CustomNavbar from "../../CustomPermissions/CustomNavbar";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../../config/api";

function LeaderTasks() {
  const { leaderId } = useParams();
  const [tasks, setTasks] = useState([]);
  const [dailyEntryData, setdailyEntryData] = useState([]);
  const [currentTasks, setCurrentTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPoints, setTotalPoints] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState({
    name: "",
    value: "",
    points: "",
    dateassigned: "",
  });
  const [inputValues, setInputValues] = useState({
    name: "",
    value: "",
    points: "",
    ename: "",
    date_joined: "",
    date_handovered: "",
    targetdays: "",
  });
  const [editFormData, setEditFormData] = useState({
    name: "",
    target: "",
    points: "",
  });
  const [taskToDelete, setTaskToDelete] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const {
    name,
    value,
    dateassigned,
    points,
    ename,
    date_joined,
    date_handovered,
    targetdays,
  } = inputValues;

  useEffect(() => {
    async function fetchTasks() {
      try {
        if (leaderId) {
          const response = await fetch(
            getApiUrl(`/LeadersTable/leader/${leaderId}/TargetsOfTasks/`)
          );
          if (!response.ok) {
            throw new Error("Failed to fetch tasks");
          }
          const data = await response.json();
          setTasks(data);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error ", error);
        setLoading(false);
      }
    }

    fetchTasks();
  }, [leaderId]);

  useEffect(() => {
    let pointsSum = 0;
    // Sum points from tasks array (convert to number to avoid string concatenation)
    tasks.forEach((task) => {
      const points = parseFloat(task.points) || 0;
      pointsSum += points;
    });
    // Also sum points from currentTasks array if it exists
    if (currentTasks && currentTasks.length > 0) {
      currentTasks.forEach((task) => {
        const points = parseFloat(task.total_points) || 0;
        pointsSum += points;
      });
    }
    setTotalPoints(pointsSum.toFixed(2));
  }, [tasks, currentTasks]);

  useEffect(() => {
    async function fetchLeaders() {
      try {
        const response = await fetch(
          getApiUrl(`/LeadersTable/leaders_id/${leaderId}/`),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const responseData = await response.json();

          setdailyEntryData(responseData.leader.currentVal);
          setTasks(responseData.leader.tasks);
        } else {
          console.log("Error fetching leader data");
        }
      } catch (error) {
        throw new Error("Failed to fetch leaders");
      }
    }

    fetchLeaders();
  }, [leaderId]);

  const openModal = (task) => {
    setSelectedTask(task);
    setInputValues({
      name: task.name,
      value: task.value,
      points: task.points,
      targetdays:
        task.name === "Induction"
          ? "1"
          : task.name === "Smooth handover Process"
          ? "4"
          : "",
    });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedTask(null);
    setIsModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        getApiUrl(`/LeadersTable/CreateTargetsOfTasks/`),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            name: selectedTask.id,
            value,
            dateassigned,
            ename,
            date_joined,
            date_handovered,
            targetdays,
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to save current month task");
      }
      setSuccessMessage("Task progress saved successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
      closeModal();
      window.location.reload(); // Refresh to show updated data
    } catch (error) {
      console.error("Error ", error);
      setErrorMessage("Failed to save task progress");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  // Edit task functions
  const openEditModal = (task) => {
    setEditFormData({
      name: task.name,
      target: task.target,
      points: task.points,
    });
    setSelectedTask(task);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedTask(null);
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData({ ...editFormData, [name]: value });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    try {
      const response = await axios.put(
        getApiUrl(`/LeadersTable/update_task/${selectedTask.id}/`),
        editFormData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      setSuccessMessage("Task updated successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
      closeEditModal();
      
      // Update local state
      setTasks(tasks.map(t => t.id === selectedTask.id ? response.data : t));
    } catch (error) {
      console.error("Error updating task:", error);
      setErrorMessage(error.response?.data?.message || "Failed to update task");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  // Delete task functions
  const openDeleteConfirm = (task) => {
    setTaskToDelete(task);
    setIsDeleteConfirmOpen(true);
  };

  const closeDeleteConfirm = () => {
    setIsDeleteConfirmOpen(false);
    setTaskToDelete(null);
  };

  const handleDeleteTask = async () => {
    setErrorMessage("");
    setSuccessMessage("");

    try {
      await axios.delete(
        getApiUrl(`/LeadersTable/delete_task/${taskToDelete.id}/`),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      setSuccessMessage("Task deleted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
      closeDeleteConfirm();
      
      // Update local state
      setTasks(tasks.filter(t => t.id !== taskToDelete.id));
    } catch (error) {
      console.error("Error deleting task:", error);
      setErrorMessage(error.response?.data?.message || "Failed to delete task");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div style={{ display: "flex" }}>
        <CustomNavbar />
        <div className="container-fluid ">
          {/* Success/Error Messages */}
          {successMessage && (
            <div className="alert alert-success mt-3" role="alert">
              {successMessage}
            </div>
          )}
          {errorMessage && (
            <div className="alert alert-danger mt-3" role="alert">
              {errorMessage}
            </div>
          )}

          <div className="row mt-3">
            <div className="col-12">
              <h2 className="taskHeader">My Tasks</h2>
            </div>
          </div>

          <div className="tableTaskDiv m-auto">
            <table className="tabletaskList w-100 text-center">
              <thead>
                <tr className="taskRow">
                  <th>Task No.</th>
                  <th>Task Name</th>
                  <th>Target</th>
                  <th>Achieved Target</th>
                  <th>Achieved Points</th>
                  <th>Total Points</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task, index) => {
                  const matchedEntry = dailyEntryData.find(
                    (entry) => entry.name_id === task.id
                  );
                  return (
                    <tr key={task.id}>
                      <td>{index + 1}</td>
                      <td>{task.name}</td>
                      <td>{task.target}</td>
                      <td>
                        {matchedEntry ? matchedEntry.total_taskinput : "-"}
                      </td>
                      <td>
                        {matchedEntry && matchedEntry.total_points != null
                          ? parseFloat(matchedEntry.total_points).toFixed(2)
                          : "-"}
                      </td>
                      <td>{task.points}</td>
                      <td>
                        <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                          <button
                            className="leaderTaskBtn"
                            onClick={() => openModal(task)}
                            title="Mark progress"
                          >
                            <i className="fa-solid fa-check"></i> Complete
                          </button>
                          <button
                            className="leaderTaskBtn"
                            style={{ backgroundColor: "#ffc107", color: "#000" }}
                            onClick={() => openEditModal(task)}
                            title="Edit task"
                          >
                            <i className="fa-solid fa-edit"></i>
                          </button>
                          <button
                            className="leaderTaskBtn"
                            style={{ backgroundColor: "#dc3545" }}
                            onClick={() => openDeleteConfirm(task)}
                            title="Delete task"
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
                {currentTasks.map((task, index) => (
                  <tr key={task.name_id}>
                    <td>{tasks.length + index + 1}</td>
                    <td>{task.task_name}</td>
                    <td>{task.target || "-"}</td>
                    <td>{task.total_taskinput}</td>
                    <td>{task.total_points}</td>
                    <td>
                      <button
                        className="leaderTaskBtn"
                        onClick={() => openModal(task)}
                      >
                        <i className="fa-solid fa-check"></i> Complete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <h3 className="taskPoint">Total Points: {typeof totalPoints === 'number' ? totalPoints.toFixed(2) : totalPoints}</h3>
        </div>

        {isModalOpen && (
          <div className="modal leaderTaskModel">
            <div className="modal-content">
              <h2>Complete Task</h2>
              <form onSubmit={handleSubmit}>
                <label className="form-label">Id:</label>
                <input type="text" value={selectedTask.id} id="name" disabled />

                <label>Value:</label>
                <input
                  type="text"
                  value={value}
                  onChange={(e) =>
                    setInputValues({ ...inputValues, value: e.target.value })
                  }
                  id="value"
                />

                <div className="form-control mb-2">
                  <label class="form-label w-100">Date: </label>
                  <input
                    type="date"
                    name="dateassigned"
                    class="w-100"
                    value={dateassigned}
                    onChange={(e) =>
                      setInputValues({
                        ...inputValues,
                        dateassigned: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                {selectedTask.name === "Induction" && (
                  <>
                    <label>Name:</label>
                    <input
                      type="text"
                      value={ename}
                      onChange={(e) =>
                        setInputValues({
                          ...inputValues,
                          ename: e.target.value,
                        })
                      }
                      id="ename"
                    />

                    <label>target Days:</label>
                    <input
                      type="text"
                      value={targetdays}
                      readOnly
                      id="targetdays"
                    />

                    <label>Date Joined:</label>
                    <input
                      type="text"
                      value={date_joined}
                      onChange={(e) =>
                        setInputValues({
                          ...inputValues,
                          date_joined: e.target.value,
                        })
                      }
                      id="date_joined"
                    />

                    <label>Date Of Handover:</label>
                    <input
                      type="text"
                      value={date_handovered}
                      onChange={(e) =>
                        setInputValues({
                          ...inputValues,
                          date_handovered: e.target.value,
                        })
                      }
                      id="date_handovered"
                    />
                  </>
                )}

                {selectedTask.name === "Smooth handover Process" && (
                  <>
                    <label>Name:</label>
                    <input
                      type="text"
                      value={ename}
                      onChange={(e) =>
                        setInputValues({
                          ...inputValues,
                          ename: e.target.value,
                        })
                      }
                      id="ename"
                    />

                    <label>target Days:</label>
                    <input
                      type="text"
                      value={targetdays}
                      readOnly
                      id="targetdays"
                    />

                    <label>Date Joined:</label>
                    <input
                      type="text"
                      value={date_joined}
                      onChange={(e) =>
                        setInputValues({
                          ...inputValues,
                          date_joined: e.target.value,
                        })
                      }
                      id="date_joined"
                    />

                    <label>Date Of Handover:</label>
                    <input
                      type="text"
                      value={date_handovered}
                      onChange={(e) =>
                        setInputValues({
                          ...inputValues,
                          date_handovered: e.target.value,
                        })
                      }
                      id="date_handovered"
                    />
                  </>
                )}

                <button type="submit" className="saveBtn">
                  Save
                </button>
                <button
                  type="button"
                  className="cancelBtn"
                  onClick={closeModal}
                >
                  Cancel
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Edit Task Modal */}
        {isEditModalOpen && (
          <div className="modal leaderTaskModel">
            <div className="modal-content">
              <h2>Edit Task</h2>
              <form onSubmit={handleEditSubmit}>
                <div className="form-group">
                  <label>Task Name:</label>
                  <input
                    type="text"
                    name="name"
                    value={editFormData.name}
                    onChange={handleEditFormChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Target:</label>
                  <input
                    type="number"
                    name="target"
                    value={editFormData.target}
                    onChange={handleEditFormChange}
                    step="0.01"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Points:</label>
                  <input
                    type="number"
                    name="points"
                    value={editFormData.points}
                    onChange={handleEditFormChange}
                    step="0.01"
                    required
                  />
                </div>

                <button type="submit" className="saveBtn">
                  Update Task
                </button>
                <button
                  type="button"
                  className="cancelBtn"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {isDeleteConfirmOpen && taskToDelete && (
          <div className="modal leaderTaskModel">
            <div className="modal-content">
              <h2 style={{ color: "#dc3545" }}>⚠️ Confirm Delete</h2>
              <p>Are you sure you want to delete the task:</p>
              <p style={{ fontWeight: "bold", fontSize: "18px", color: "#007bff" }}>
                "{taskToDelete.name}"?
              </p>
              <p style={{ color: "#666", fontSize: "14px" }}>
                This action cannot be undone.
              </p>
              <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
                <button
                  className="saveBtn"
                  style={{ backgroundColor: "#dc3545" }}
                  onClick={handleDeleteTask}
                >
                  Delete
                </button>
                <button className="cancelBtn" onClick={closeDeleteConfirm}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LeaderTasks;
